"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tagReplacer_1 = __importDefault(require("./tagReplacer"));
var getOptionsWithDefaults_1 = __importDefault(require("./getOptionsWithDefaults"));
var cache = __importStar(require("./cache"));
var expectedOptionKeys = [
    "tagPattern",
    "tagStartPattern",
    "tagEndPattern",
    "cache",
    "onMissingPath",
    // ignored keys:
    "name",
    "openingTag",
    "closingTag",
];
/**
 * Replaces tags in a text with corresponding values from an object.
 * @param {string} text - The text containing tags to be replaced.
 * @param {object | string} values - The object containing values for replacement.
 * @param {ReplaceTagsOptions} [options] - Optional configuration for tag parsing.
 * @returns {string} The text with replaced tags.
 */
var replaceTags = function (text, values, options) {
    var _a;
    if (typeof text !== "string")
        return text;
    if (typeof values === "string") {
        values = JSON.parse(values);
    }
    if (typeof options === "object" && options !== null) {
        Object.keys(options).every(function (key) {
            if (!expectedOptionKeys.includes(key)) {
                throw new Error("Unexpected option key: ".concat(key));
            }
            return true;
        });
    }
    var _b = (0, getOptionsWithDefaults_1.default)(options), onMissingPath = _b.onMissingPath, tagPattern = _b.tagPattern, tagStartPattern = _b.tagStartPattern, tagEndPattern = _b.tagEndPattern;
    var pattern = tagPattern;
    var tagEdges = new RegExp("".concat(tagStartPattern.source + "\\s*", "|").concat("\\s*" + tagEndPattern.source), "g");
    var keepCache = (_a = options === null || options === void 0 ? void 0 : options.cache) !== null && _a !== void 0 ? _a : false;
    if (!keepCache)
        cache.clear();
    try {
        return text.replace(pattern, (0, tagReplacer_1.default)(values, tagEdges, onMissingPath));
    }
    finally {
        if (!keepCache)
            cache.clear();
    }
};
exports.default = replaceTags;
